export interface ResultOverlayOptions {
  title: string
  rewardText: string
  primaryLabel: string
  collectionLabel: string
  passLabel: string
  menuLabel: string
  onPlayAgain: () => void
  onCollection: () => void
  onPass: () => void
  onMenu: () => void
}

export interface ResultOverlayHandle {
  setRewardText: (text: string) => void
  destroy: () => void
}

export function mountResultOverlay(options: ResultOverlayOptions): ResultOverlayHandle {
  const root = document.createElement('div')
  root.className = 'game-result-overlay'

  const panel = document.createElement('section')
  panel.className = 'game-result-panel'

  const title = document.createElement('h2')
  title.className = 'game-result-panel-title'
  title.textContent = options.title

  const rewards = document.createElement('p')
  rewards.className = 'game-result-rewards'
  rewards.textContent = options.rewardText

  const primary = button(options.primaryLabel, 'game-result-primary', options.onPlayAgain)
  const row = document.createElement('div')
  row.className = 'game-result-secondary-row'
  row.append(
    button(options.collectionLabel, 'game-result-secondary game-result-collection', options.onCollection),
    button(options.passLabel, 'game-result-secondary game-result-pass', options.onPass),
  )
  const menu = button(options.menuLabel, 'game-result-menu', options.onMenu)

  panel.append(title, rewards, primary, row, menu)
  root.append(panel)
  document.body.append(root)

  return {
    setRewardText: (text: string) => {
      rewards.textContent = text
    },
    destroy: () => root.remove(),
  }
}

function button(label: string, className: string, onClick: () => void): HTMLButtonElement {
  const btn = document.createElement('button')
  btn.type = 'button'
  btn.className = `game-result-btn ${className}`
  btn.textContent = label
  btn.addEventListener('click', onClick)
  return btn
}
